import {
    NEW_FAZENDA_CADASTRO_SUCCESS,
    TABLE_FAZENDA_CADASTRO_PENDING,
    TABLE_FAZENDA_CADASTRO_SUCCESS,
    TABLE_FAZENDA_CADASTRO_FAILURE,
    LIST_FAZENDA_CADASTRO_PENDING,
    LIST_FAZENDA_CADASTRO_SUCCESS,
    LIST_FAZENDA_CADASTRO_FAILURE,
    FIND_FAZENDA_CADASTRO_PENDING,
    FIND_FAZENDA_CADASTRO_SUCCESS,
    FIND_FAZENDA_CADASTRO_FAILURE,
    DELETE_FAZENDA_CADASTRO_PENDING,
    DELETE_FAZENDA_CADASTRO_SUCCESS,
    DELETE_FAZENDA_CADASTRO_FAILURE,
    CREATE_FAZENDA_CADASTRO_PENDING,
    CREATE_FAZENDA_CADASTRO_SUCCESS,
    CREATE_FAZENDA_CADASTRO_FAILURE,
} from './actionTypes';

const initialState = { list: null, loading: false }

function fazendaCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_FAZENDA_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_FAZENDA_CADASTRO_PENDING:
        case FIND_FAZENDA_CADASTRO_PENDING:
        case DELETE_FAZENDA_CADASTRO_PENDING:
        case CREATE_FAZENDA_CADASTRO_PENDING:
        case TABLE_FAZENDA_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_FAZENDA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_FAZENDA_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_FAZENDA_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_FAZENDA_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_FAZENDA_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_FAZENDA_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_FAZENDA_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_FAZENDA_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case CREATE_FAZENDA_CADASTRO_FAILURE:
        case DELETE_FAZENDA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state;
    }
}

export { fazendaCadastroReducer };